const STEPS = {
  DATOS_COMUNICACION: 1,
  DATOS_PERSONALES: 2,
  PERSONAS_ARCHIVOS: 3,
  OK: 4,
};

const STEPS_ARRAY = [
  {
    id: STEPS.DATOS_COMUNICACION,
    title: 'Datos de la comunicación',
  },
  {
    id: STEPS.DATOS_PERSONALES,
    title: 'Datos personales',
  },
  {
    id: STEPS.PERSONAS_ARCHIVOS,
    title: 'Personas relacionadas y Archivos adjuntos',
  },
];

export { STEPS, STEPS_ARRAY };
